import { CloseRounded } from "@mui/icons-material";
import { Modal } from "@mui/material";

import {
  Container,
  Title,
  Wrapper,
  Image,
  Tags,
  Desc,
  Tag,
} from "./ProjectDetailsStyles";

const ProjectDetails = ({ openModalProject, setOpenModalProject }) => {
  const project = openModalProject?.project;

  return (
    <Modal
      open={true}
      onClose={(_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          setOpenModalProject({ state: false, project: null });
        }
      }}
    >
      <Container>
        <Wrapper>
          <CloseRounded
            style={{
              position: "absolute",
              top: "10px",
              right: "20px",
              cursor: "pointer",
            }}
            onClick={() => setOpenModalProject({ state: false, project: null })}
          />
          <Image src={project?.image} />
          <Title>{project?.title}</Title>
          <Tags>
            {project?.tags.map((tag, index) => (
              <Tag key={index}>{tag}</Tag>
            ))}
          </Tags>
          <Desc>{project?.description}</Desc>
        </Wrapper>
      </Container>
    </Modal>
  );
};

export default ProjectDetails;
